/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('babel-runtime/helpers/defineProperty'));
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));

// todo uncomment when IE 11 will die
// const SERVICES_PROP = Symbol('services')
var SERVICES_PROP = 'services';
/**
 * Service container mixin
 */
var services = {
  inject: {
    $services: SERVICES_PROP
    // todo works only in Vue 2.5.x
    // $services: {from: SERVICES_PROP, default: Object.create(null)},
  },
  provide: function provide() {
    return _defineProperty({}, SERVICES_PROP, this.getServices());
  },

  methods: {
    /**
     * @returns {Object}
     * @protected
     */
    getServices: function getServices() {
      return mergeDescriptors({}, this.$services || {});
    }
  },
  beforeCreate: function beforeCreate() {
    var source = this.$parent;
    while (source) {
      if (source._provided && SERVICES_PROP in source._provided) {
        break;
      }
      source = source.$parent;
    }
    if (!source || !(SERVICES_PROP in source._provided)) {
      delete this.$options.inject.$services;
    }
  }
};

module.exports = services;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/services.js
// module id = 521
// module chunks = 1